import { request } from '../api/client';
import type { FileProperties } from '../features/files/FilePropertiesDialog';
import type { MediaSource } from './mediaReview';
import { originalVideoEndpoint, originalVideoPayload } from './originalVideo';

export function readOriginalVideoProperties(source: MediaSource, signal: AbortSignal): Promise<FileProperties> {
  if (new URL(source.url, location.href).protocol === 'blob:') {
    return Promise.reject(new Error('Свойства оригинала доступны после загрузки файла в Скрепку.'));
  }
  return request<FileProperties>(originalVideoEndpoint(source) + 'properties', {
    method: 'POST', signal, cache: 'no-store',
    body: originalVideoPayload(source),
  });
}
